import React from 'react'

function SubTitle({subtitle}) {
  return (
    <div className='sub-title'>
       <h4>
          {subtitle}
       </h4>
    </div>
  )
}

export default SubTitle
